<template>
  <v-app-bar
    height="auto"
    class="
      mt-3
      px-0
      mx-3
      border-radius-xl
      toolbar-content-padding-y-none
      bg-transparent
    "
    :class="
      navbarFixed
        ? 'position-sticky blur shadow-blur top-1 z-index-sticky py-2'
        : ''
    "
    flat
  >
    <v-row class="py-1">
      <v-col
        sm="6"
        class="d-flex align-center justify-left justify-sm-start"
      >
        <img
          src="@/assets/logo.jpg"
          width="120"
          alt="CortiOS Logo"
          class="w-28"
        />
      </v-col>
      <v-col
        sm="6"
        class="d-flex align-center"
        :class="$vuetify.rtl ? 'text-sm-left' : 'text-sm-right'"
      >
        <v-form
          v-if="hasBg"
          @submit.prevent="submit"
          class="navbar-search navbar-search-light d-inline-block ms-auto"
          id="navbar-search-main"
        >
          <v-text-field
            rounded-sm
            hide-details
            outlined
            background-color="rgba(255,255,255,.9)"
            color="rgba(0,0,0,.6)"
            light
            placeholder="Type here..."
            class="
              input-style
              font-size-input
              placeholder-lighter
              input-alternative input-icon
              border
            "
          >
            <template slot="prepend-inner">
              <v-icon color="rgba(0,0,0,.6)" size=".875rem"
                >fas fa-search</v-icon
              >
            </template>
          </v-text-field>
        </v-form>
        <v-btn
            :ripple="false"
            icon
            outlined
            rounded
            color="primary"
            width="34px"
            height="34px"
            class="d-flex align-center justify-center ms-6"
        >
          <v-icon size="16">fa fa-user text-sm</v-icon>
        </v-btn>

        <v-btn
          elevation="0"
          :ripple="false"
          height="43"
          class="
            font-weight-600
            text-capitalize
            drawer-toggler
            py-3
            px-0
            rounded-sm
          "
          :class="{
            'btn-dark-toggler-hover': !hasBg,
            'btn-toggler-hover': hasBg,
            active: togglerActive,
          }"
          v-if="$vuetify.breakpoint.mobile"
          color="transparent"
          @click="drawerClose"
        >
          <div class="drawer-toggler-inner">
            <i class="drawer-toggler-line text-body primary"></i>
            <i class="drawer-toggler-line text-body primary"></i>
            <i class="drawer-toggler-line text-body primary"></i>
          </div>
        </v-btn>
        <v-switch class="mt-4" v-model="$vuetify.theme.dark"></v-switch>
        <v-menu
          transition="slide-y-transition"
          offset-y
          offset-x
          min-width="300"
          max-width="300"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              :ripple="false"
              :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
              class="text-body"
              color="primary"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon size="30">fa fa-bell text-sm</v-icon>
            </v-btn>
          </template>

          <v-list class="py-0" @click="goToPage('alerts')">
            <v-list-item
              v-for="(item, i) in dropdown"
              :key="i"
              class="pa-4 list-item-hover-active"
            >
              <v-list-item-avatar
                :size="36"
                class="my-0 me-4 border-radius-lg"
                v-if="item.avatar"
              >
                <v-img
                  :alt="`${item.avatar} avatar`"
                  :src="item.avatar"
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-avatar
                :size="36"
                class="my-0 me-4 border-radius-lg bg-gradient-default"
                v-if="item.image"
              >
                <v-img :alt="`${item.image} image`" :src="item.image"></v-img>
              </v-list-item-avatar>

              <v-list-item-avatar
                :size="36"
                class="my-0 me-4 border-radius-lg bg-gradient-secondary"
                v-if="item.icon"
              >
                <v-img
                  :alt="`${item.icon} icon`"
                  :src="item.icon"
                  class="pa-2"
                  width="10"
                  height="10"
                  contain
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  <v-row>
                    <v-col>
                      <h6
                        class="text-sm font-weight-normal mb-1 text-typo"
                        v-html="item.title"
                      >
                        {{ item.title }}
                      </h6>
                    </v-col>
                  </v-row>
                </v-list-item-title>

                <p class="text-xs text-secondary mb-0">
                  <v-icon size="12" class="text-secondary"
                    >fa fa-clock me-1</v-icon
                  >
                  {{ item.time }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>
import router from '../router';
import { activateDarkMode, deactivateDarkMode } from "@/assets/js/dark-mode";

export default {
  name: "app-bar",
  props: {
    background: String,
    hasBg: Boolean,
    linkColor: String,
    toggleActive: String,
    navbarFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDarkMode: false,
      drawer: false,
      togglerActive: false,
      dropdown: [
        {
          icon: require("@/assets/img/icons/card.svg"),
          title:
            '<span class="font-weight-bold">Your stress level is high</span>',
          time: "13 minutes ago",
        },
        {
          icon: require("@/assets/img/icons/card.svg"),
          title:
            '<span class="font-weight-bold">Fatigue % has increased beyond normal levels</span>',
          time: "1 hour ago",
        },
        {
          icon: require("@/assets/img/icons/card.svg"),
          title: "Your heart rate is above normal",
          time: "2 hours ago",
        },
      ],
    };
  },
  methods: {
    goToPage(page) {
      this.$emit("go-to-page", page);
      router.push({ name: 'Alerts' });
    },
    drawerClose() {
      this.togglerActive = !this.togglerActive;
      this.$emit("drawer-toggle", true);
    },
    darkMode() {
      if (this.isDarkMode) {
        this.isDarkMode = false;
        deactivateDarkMode();

      } else {
        this.isDarkMode = true;
        activateDarkMode();
      }
    },
    minifyDrawer() {
      this.togglerActive = !this.togglerActive;
      this.mini = !this.mini;
      const body = document.getElementsByTagName("body")[0];

      if (body.classList.contains("drawer-mini")) {
        body.classList.remove("drawer-mini");
      } else {
        body.classList.add("drawer-mini");
      }
    },
  },
  watch: {
    toggleActive(val) {
      this.togglerActive = val;
    },
  },
};
</script>
